var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    staticClass: "node h-[8%] sm:h-[5%] ease-in-out duration-200",
    attrs: {
      "viewBox": "0 0 30 30",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "filter": "url(#filter0_d_1922_69808)"
    }
  }, [_c('rect', {
    attrs: {
      "x": "10",
      "y": "18",
      "width": "10",
      "height": "10",
      "rx": "5",
      "transform": "rotate(-90 10 18)",
      "fill": "currentColor"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "9",
      "y": "19",
      "width": "12",
      "height": "12",
      "rx": "6",
      "transform": "rotate(-90 9 19)",
      "stroke": "white",
      "stroke-width": "2",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('filter', {
    attrs: {
      "id": "filter0_d_1922_69808",
      "x": "0",
      "y": "0",
      "width": "30",
      "height": "30",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "in": "SourceAlpha",
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      "result": "hardAlpha"
    }
  }), _vm._v(" "), _c('feOffset', {
    attrs: {
      "dy": "2"
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "4"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in2": "hardAlpha",
      "operator": "out"
    }
  }), _vm._v(" "), _c('feColorMatrix', {
    attrs: {
      "type": "matrix",
      "values": "0 0 0 0 0.439375 0 0 0 0 0.453175 0 0 0 0 0.4625 0 0 0 0.5 0"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in2": "BackgroundImageFix",
      "result": "effect1_dropShadow_1922_69808"
    }
  }), _vm._v(" "), _c('feBlend', {
    attrs: {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "effect1_dropShadow_1922_69808",
      "result": "shape"
    }
  })], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }